import { QuestionWithRelations } from "../../../../api/src/types";
import Checkbox from "./questionnaireInputs/Checkbox";
import Radio from "./questionnaireInputs/Radio";
import Dropdown from "./questionnaireInputs/Dropdown";
import TextAreaInput from "./questionnaireInputs/TextArea";
import TextFieldInput from "./questionnaireInputs/TextField";
import CurrencyField from "./questionnaireInputs/CurrencyField";
import NumberField from "./questionnaireInputs/NumberField";
import DateField from "./questionnaireInputs/DateField";
import PhoneInputField from "./questionnaireInputs/PhoneField";
import ReadOnlyQuestion from "./utils/ReadOnlyQuestion";

interface QuestionRendererProps {
  question: QuestionWithRelations;
  isReadOnly?: boolean;
}

const QuestionRenderer: React.FC<QuestionRendererProps> = ({
  question,
  isReadOnly = false,
}) => {
  // Feature for attorneys
  if (isReadOnly) {
    return <ReadOnlyQuestion question={question} />;
  }
  // Render input based on question type
  switch (question.questionType) {
    case "CHECKBOX":
      return <Checkbox question={question} />;

    case "RADIO":
      return <Radio question={question} />;

    case "DROPDOWN":
      return <Dropdown question={question} />;

    case "TEXT_AREA":
      return <TextAreaInput question={question} />;

    case "TEXT_BOX":
      // For TEXT_BOX, further check the inputType
      switch (question.inputType) {
        case "CURRENCY":
          return <CurrencyField question={question} />;
        case "NUMBER":
          return <NumberField question={question} />;
        case "DATE":
          return <DateField question={question} />;
        case "PHONE":
          return <PhoneInputField question={question} />;
        default:
          return <TextFieldInput question={question} />;
      }
    default:
      // Default to text field input for any unknown question type
      return <TextFieldInput question={question} />;
  }
};

export default QuestionRenderer;
